import { render } from "./TreatmentPlanList.vue?vue&type=template&id=a5ffffdc&scoped=true"
import script from "./TreatmentPlanList.vue?vue&type=script&lang=js"
export * from "./TreatmentPlanList.vue?vue&type=script&lang=js"

import "./TreatmentPlanList.vue?vue&type=style&index=0&id=a5ffffdc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5ffffdc"]])

export default __exports__